import { LiveAnnouncer } from '@angular/cdk/a11y';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, inject, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatChipInputEvent, MatChipGrid, MatChipRow, MatChipRemove, MatChipInput } from '@angular/material/chips';
import { MatDialog, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { map, Observable, startWith, Subject, takeUntil } from 'rxjs';
import { ApiResponse, CamDeleteModel } from 'src/app/models/interface/CAM/baseResponseInterfaces';
import { Branch } from 'src/app/models/interface/CAM/CompanyProfileInterface';
import { Designation, DesignationRequest } from 'src/app/models/interface/CAM/TravellerInterface';
import { CamService } from 'src/app/services/camService/cam.service';
import { CompanyManagementService } from 'src/app/services/dataLayer/CAM/company-management.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { CompanyManagementContentService } from '../../services/company-management-content.service';
import { MatAutocompleteTrigger, MatAutocomplete, MatOption } from '@angular/material/autocomplete';
import { DisctionaryContent } from 'src/app/services/sitecoreDictionary/dictionary-content.service';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatLabel, MatError, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatButton } from '@angular/material/button';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { CamEmptyStateComponent } from '../cam-empty-state/cam-empty-state.component';
import { CdkScrollable } from '@angular/cdk/scrolling';

@Component({
    selector: 'app-designation',
    templateUrl: './designation.component.html',
    styleUrls: ['./designation.component.scss'],
    imports: [ReactiveFormsModule, NgIf, MatIcon, MatFormField, MatLabel, MatInput, MatError, MatChipGrid, NgFor, MatChipRow, MatChipRemove, MatChipInput, MatAutocompleteTrigger, MatSuffix, MatAutocomplete, MatOption, MatCheckbox, MatButton, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, CamEmptyStateComponent, CdkScrollable, MatDialogContent, MatDialogActions, AsyncPipe]
})
export class DesignationComponent implements OnInit, OnDestroy {
  @ViewChild(MatAutocompleteTrigger)
  autocomplete!: MatAutocompleteTrigger;
  @ViewChild('selectionWarning') selectionWarning!: TemplateRef<any>;

  displayedColumns: string[] = ['Designation', 'Actions'];
  Addnew: boolean = false;
  designationForm!: FormGroup;
  isEdit: boolean = false;
  isLoading = true;
  selectedBranchIdsMap: { [key: number]: boolean } = {};
  commonObjPipes: any = {
    GetAllDetails: { pipe: [] as Designation[], all: [] as Designation[] },
    GetAssociatedWithBranchId: { pipe: [] as Branch[], all: [] as Branch[] },
  };
  separatorKeysCodes: number[] = [ENTER, COMMA];
  associateWithBranch = new FormControl('');
  filteredBranch: Observable<any[]>;
  branchName: string[] = [];
  announcer = inject(LiveAnnouncer);
  currentItem: any;
  noRecordFound: boolean = false;
  private destroy$ = new Subject<void>();
  content:any;
  dictionaryContent:any;
  constructor(private readonly _camService: CamService, private readonly fb: FormBuilder, private readonly dialog: MatDialog, private readonly _ToastrApiService: ToastrApiService, public _CommonService: CommonService, private readonly _CompanyManagementService:CompanyManagementService, private readonly contentService:CompanyManagementContentService, private readonly dictionaryContentService:DisctionaryContent) {
    this.designationForm = this.fb.group({
      flag: ['ADD'],
      designationId: [null],
      designation: ['', [Validators.required, Validators.maxLength(100)]],
      associateWithBranch: ['', [Validators.required]]
    });
    this.filteredBranch = this.associateWithBranch.valueChanges.pipe(startWith(null), map((value: string | null) => {
      if (typeof value === 'string') {
        return this._filter(value);
      } else {
        return this.commonObjPipes.GetAssociatedWithBranchId.pipe.slice();
      }
    }));
  }

  ngOnInit(): void {
    this.contentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
      this.content = res;
    });
    this.dictionaryContentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
      this.dictionaryContent = res;
    });
    this.getDesignation()
    this.loadInitialData()
  }

  async loadInitialData() {
    try {
      this.isLoading = true;
      const [branches] = await Promise.all([
        // this._camService.getDesignationDetails(),
        this._camService.GetBranchInformation()
      ]);
      // this.bindLists('GetAllDetails', designation.data);
      this.bindLists('GetAssociatedWithBranchId', branches.data);
    } catch (error) {
      console.error(error);
      this._ToastrApiService.show('error', 'Failed to load department data.');
    } finally {
      this.isLoading = false;
    }
  }

  handleEvent(event: string) {
    if (event.includes('designation')) {
      this.Addnew = true;
    }
  }

  addNewDesignation() {
    this.Addnew = true;
    this.isEdit = false;
    this.designationForm.reset({
      designationId: null,
      flag:'ADD'
    });
    this.selectedBranchIdsMap = {};
    this.branchName = [];

    this._CompanyManagementService.company_management_designation('Add link','Add',this.commonObjPipes.GetAllDetails.pipe.length)//GTM use
  }

  getDesignation() {
    this._camService.getDesignationDetails().then((res: ApiResponse<Designation[]>) => {


           // 🔥 Handle null API response
      // if (!res || res === null || !res.data || res.data === null) {

      //   this._ToastrApiService.show('error', 'No content available');
      //   return;
      // }
      if (res.status == 'Success') {
         this.bindLists('GetAllDetails', res.data);
      }
    }).catch((error) => {
      this.bindLists('GetAllDetails',[]);
      console.error(error);
    }).finally(() => {
      this.isLoading = false;
    });
  }

  bindLists(key: string, lists: any[]) {
    this.commonObjPipes[key].pipe = lists;
    this.commonObjPipes[key].all = lists;
  }

  onCheckboxChange(event: any, branch: any, parentClass: string, matAutoClassRef: string) {
    this.selectedBranchIdsMap[branch.corpBranchId] = event.checked;
    if (event.checked) {
      if (!this.branchName.includes(branch.corpBranchName)) {
        this.branchName.push(branch.corpBranchName);
      }
    } else {
      this.branchName = this.branchName.filter(name => name != branch.corpBranchName);
    }
    const selectedBranchId = Object.keys(this.selectedBranchIdsMap).filter(key => this.selectedBranchIdsMap[parseInt(key)]).map(key => parseInt(key));
    this.designationForm.controls['associateWithBranch'].setValue(selectedBranchId.join(','));
    this.designationForm.controls['associateWithBranch'].updateValueAndValidity();
    requestAnimationFrame(() => this.CustomMatAutoPosition(parentClass, matAutoClassRef));
    // if (event.checked) {
    //   this.selectedBranchIdsMap[branch.corpBranchId] = true;
    // } else {
    //   delete this.selectedBranchIdsMap[branch.corpBranchId];
    // }
  }

  CustomMatAutoPosition(parentClass: string, matAutoClassRef: string) {
    let parent = (document.querySelector(`.${parentClass}`) as HTMLDivElement).getBoundingClientRect();
    (document.querySelector('.cdk-overlay-connected-position-bounding-box .cdk-overlay-pane') as HTMLDivElement)?.style.setProperty('top', `${parent.top + parent.height}px`, 'important');
  }



/**
 * @function onSave
 * @description
 * Handles the save operation for Designation form (Add or Update).
 * The method:
 * 1. Validates the form.
 * 2. Constructs a request object based on form values.
 * 3. Sends the data to the backend API using CamService.
 * 4. Displays appropriate success or error messages based on the API response.
 * 5. Resets form state and refreshes the designation list after a successful operation.
 */
  onSave() {
    this._CompanyManagementService.company_management_designation('Save button','Save',this.commonObjPipes.GetAllDetails.pipe.length)//GTM use
    if (this.designationForm.invalid) {
      this.designationForm.markAllAsTouched();
      return;
    }
    const requstData: DesignationRequest = {
      flag: this.designationForm.value.flag,
      designationId: this.designationForm.value.designationId,
      designation: this.designationForm.value.designation,
      associateWithBranch: this.designationForm.value.associateWithBranch
    }
    this._camService.insertUpdateDesignationDetailsV1(requstData).then((res) => {
      if (!res) {
        this._ToastrApiService.show('error', 'No response received from server.');
        return;
      }
      localStorage.setItem('designation',this.designationForm.value.designation);
      // Handle API response
      switch (res.status) {
        case 'Created':
          this._ToastrApiService.show('success', res.message || 'Designation created successfully.');
          this._CompanyManagementService.save_success('Designation', 'Success')//GTM use
          break;

        case 'Success':
          this._ToastrApiService.show('success', res.message || 'Designation updated successfully.');
          this._CompanyManagementService.save_success('Designation', 'Success')//GTM use
          break;

        case 'Conflict':
          this._ToastrApiService.show('warning', res.message || 'Designation entry detected.');
          break;

        default:
          this._ToastrApiService.show('error', res.message || 'Unexpected response from server.');
          console.warn('Unhandled status:', res);
          break;
      }
      this.getDesignation()
      this.Addnew = false;
      this.isEdit = false;
      this._CommonService.formResetTrigger();
    }).catch((error) => {
      console.error(error)
      const errorMessage =
        error?.error?.message ||
        error?.message ||
        'Something went wrong while saving the department. Please try again later.';
      this._CompanyManagementService.view_error_message(errorMessage,error?.code);
      this._ToastrApiService.show('error', errorMessage);
    });
  }


  onEdit(item: Designation) {
    this._CompanyManagementService.company_management_designation('Edit button','Edit',this.commonObjPipes.GetAllDetails.pipe.length)//GTM use
    this.Addnew = true;
    this.isEdit = true;
    const associatedBranchIds = item.associatedWithBranchId ? item.associatedWithBranchId.split(',').map((id: string) => parseInt(id, 10)) : [];
    this.designationForm.patchValue({
      flag:'UPDATE',
      designationId: item.designationId,
      designation: item.designation,
      associateWithBranch: associatedBranchIds.join(',')
    });
    this.selectedBranchIdsMap = {};
    this.branchName = [];
    associatedBranchIds.forEach((branchId: any) => {
      this.selectedBranchIdsMap[branchId] = true;
      const branch = this.commonObjPipes.GetAssociatedWithBranchId.pipe.find((b: { corpBranchId: any; }) => b.corpBranchId === branchId);
      if (branch) {
        this.branchName.push(branch.corpBranchName);
      }
    });
  }

  onRemove(item: Designation) {
    this._CompanyManagementService.company_management_designation('Remove button','Remove',this.commonObjPipes.GetAllDetails.pipe.length)//GTM use
    this.currentItem = item;
    const dialogRef = this.dialog.open(this.selectionWarning, {
      data: item, // Pass the item data
    });
  }

  confirmDelete(item: Designation) {

       const request: CamDeleteModel = {
          id: item.designationId,
          type: 'DESIGNATION'
        }

    this._camService.DeleteCAMitemBytype(request).then((res) => {
      this._ToastrApiService.show('success', res.message);
      if (res.status == "Success") {
        console.log('deleted',res);
        this.currentItem = undefined;
        this.getDesignation()
        this._CompanyManagementService.designation_remove_Successfully('Confirm','Success')//GTM use
      }
    }).catch((error) => {
      console.error(error)
      const errorMessage =
        error?.error?.message ||
        error?.message ||
        'Something went wrong while delete the designation. Please try again later.';
        this._CompanyManagementService.view_error_message(errorMessage,error?.code);
      this._ToastrApiService.show('error', errorMessage);
    });
  }

  CloseDialog(result: boolean) {
    if (result) {
      this.confirmDelete(this.currentItem);
      this._CompanyManagementService.designation_remove('Proceed','Are you sure you want to remove this Designation?')//GTM use
    }
    if(!result){
      this._CompanyManagementService.designation_remove('Cancel','Are you sure you want to remove this Designation?')//GTM use

    }
    this.dialog.closeAll();
  }

  onCancel() {
    this.Addnew = false;
    this.isEdit = false;
    this.designationForm.reset();
    this._CompanyManagementService.company_management_designation('Cancel button','Cancel',this.commonObjPipes.GetAllDetails.pipe.length)//GTM use
  }

  //dropdown down chips all methods
  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value) {
      const matchingBranch = this.commonObjPipes.GetAssociatedWithBranchId.pipe.find((branch: { Name: string; }) => branch.Name.toLowerCase() === value.toLowerCase());
      if (matchingBranch) {
        this.onCheckboxChange({ checked: true, stopPropagation: () => { } }, matchingBranch, 'custom-designation-mat-dropdown-parent', 'custom-autocomplete');
        return this.commonObjPipes.GetAssociatedWithBranchId.pipe.slice();
      }
      else {
        return this.commonObjPipes.GetAssociatedWithBranchId.pipe.slice();
      }
    }
    // Clear the input value
    event.chipInput!.clear();
    this.associateWithBranch.setValue(null);
    let parent = (document.querySelector(`.${'custom-designation-mat-dropdown-parent'}`) as HTMLDivElement).getBoundingClientRect();
    (document.querySelector(`.${'custom-autocomplete'}`) as HTMLDivElement).style.marginTop = `${parent.top + parent.height}px`;
  }

  remove(name: string): void {
    const index = this.branchName.indexOf(name);
    if (index >= 0) {
      this.branchName.splice(index, 1);
      this.announcer.announce(`Removed ${name}`);
      const branch = this.commonObjPipes.GetAssociatedWithBranchId.pipe.find((branch: { corpBranchName: string; }) => branch.corpBranchName == name)
      if (branch) {
        this.selectedBranchIdsMap[branch.corpBranchId] = false;
        const selectedBranchId = Object.keys(this.selectedBranchIdsMap).filter(key => this.selectedBranchIdsMap[parseInt(key)]).map(key => parseInt(key));
        this.designationForm.controls['associateWithBranch'].setValue(selectedBranchId.join(','));
        this.designationForm.controls['associateWithBranch'].updateValueAndValidity();
      }
    }
  }

  private _filter(value: string): any[] {
    const filterValue = value.toLowerCase();
    const filteredData = this.commonObjPipes.GetAssociatedWithBranchId.pipe.filter((branch: { Name: string }) => branch.Name.toLowerCase().includes(filterValue));
    this.noRecordFound = filteredData.length == 0;
    return filteredData
  }

  optionClicked(branch: any) {
    const newCheckedState = !this.selectedBranchIdsMap[branch.ID];
    const mockEvent = {
      checked: newCheckedState,
      stopPropagation: () => { }
    };
    this.onCheckboxChange(mockEvent, branch, 'custom-designation-mat-dropdown-parent', 'custom-autocomplete');
  };

//ADD THIS TO COMMON
    blockInvalidChars(event: KeyboardEvent): void {
    const allowedRegex = /^[a-zA-Z0-9&.\s\-]$/;
    if (!allowedRegex.test(event.key)) {
      event.preventDefault();
    }
  }
  ngOnDestroy(){
    this.destroy$.next();
    this.destroy$.complete();
  }
}